<template>
  <div id="app">
    <keep-alive :include="hasView">
      <router-view v-if="RouterState" />
    </keep-alive>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      RouterState: true,
    };
  },
  provide() {
    return {
      reload: this.reload,
      judgeApp: this.judgeApp,
    };
  },
  computed: {
    ...mapGetters(["hasView"]),
    key() {
      return this.$route.fullPath;
    },
  },
  watch: {
    $route: {
      handler(to, from) {
        setTimeout(() => {
          //避免首次获取不到window._czc
          if (window._czc) {
            let location = window.location;
            let contentUrl = location.pathname + location.hash;
            let refererUrl = "/";
            // 用于发送某个URL的PV统计请求，
            window._czc.push(["_trackPageview", contentUrl, refererUrl]);
            window._czc.push(["_setAutoPageview", false]);
          }
        }, 300);
      },
      immediate: true, // 首次进入页面即执行
    },
  },
  created() {
    this.$http.post("cms/onlineUser/reg/isLogin.do").then((res) => {
      if (res.success) {
        this.$store.dispatch("saveInfo", res.obj);
      }
    });
  },
  mounted() {
    this.initCNZZ();
    // window.location.replace(window.location.href.replace(window.location.search, '') + window.location.search)
  },
  methods: {
    initCNZZ() {
      //添加脚本
      const script = document.createElement("script");
      script.src =
        "https://s13.cnzz.com/z_stat.php?id=1274037783&web_id=1274037783";
      script.language = "JavaScript";
      script.id = "cnzz";
      document.body.appendChild(script);
    },

    judgeApp() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        return "isAndroid";
      }
      if (isIOS) {
        return "isIOS";
      }
    },
    reload() {
      this.RouterState = false;
      this.$nextTick(() => {
        this.RouterState = true;
      });
    },
  },
};
</script>

<style lang="less">
.download_btn {
  position: fixed;
  z-index: 9999;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.app-main {
  /*84 = navbar + tags-view = 50 +34 */
  min-height: calc(100vh - 100px);
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: #f2f2f2;
}
// 过渡动画
.slide-fade-enter-active {
  transition: all 0.15s ease;
}
.slide-fade-leave-active {
  transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter {
  transform: translateX(-10px);
}
.slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  // opacity: 0;
}
// 过渡动画
.slide-enter-active {
  transition: all 0.4s;
}
.slide-leave-active {
  transition: all 0.8s;
}
.slide-enter, .slide-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateY(200vh);
}
// 过渡动画
.slide-y-enter-active {
  transition: all 0.2s;
}
.slide-y-leave-active {
  transition: all 0s;
}
.slide-y-enter, .slide-y-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateY(10vh);
}
.fade-enter-active {
  transition: all 0.4s;
}
.fade-leave-active {
  transition: all 0.8s;
}
.fade-enter, .fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  opacity: 0;
}
.main_con {
  max-width: 7.5rem;
  margin: 0 auto;
}
.no_data {
  padding-top: 20vh;
  text-align: center;
  font-size: 0.24rem;
  color: #999;
  img {
    width: 5.5rem;
    margin: 0 auto 0.4rem;
    display: block;
  }
}
</style>
